export const assertNever = (value: never, message?: string): never => {
    throw new Error(message ? `${message}: ${value}` : `Unexpected value: ${JSON.stringify(value, undefined, 2)}`);
};
